import { render, staticRenderFns } from "./PopupResvDoctor.vue?vue&type=template&id=450a3266&scoped=true&"
import script from "./PopupResvDoctor.vue?vue&type=script&lang=ts&"
export * from "./PopupResvDoctor.vue?vue&type=script&lang=ts&"
import style0 from "./PopupResvDoctor.vue?vue&type=style&index=0&id=450a3266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a3266",
  null
  
)

export default component.exports